import { MutationObserverOptions, useMutation } from 'react-query';
import { ethers } from 'ethers';

import FunctionKey from 'constants/functionKey';

import mintUmi, { MintUmiInput, MintUmiOutput } from './index';
import queryClient from '../../queryClient';

type TrimmedMintUmiInput = Omit<MintUmiInput, 'userSigner'>;

export interface UseMintUmiInput extends TrimmedMintUmiInput {
  userSigner?: ethers.Signer;
}

type Options = MutationObserverOptions<MintUmiOutput, Error, UseMintUmiInput>;

const useMintUmi = (options?: Options) =>
  useMutation(
    FunctionKey.MINT_UMI,
    async (params: UseMintUmiInput) => {
      if (!params.userSigner) {
        throw new Error('User signer is required');
      }

      return mintUmi({
        ...params,
        userSigner: params.userSigner,
      });
    },
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_UMI);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );

export default useMintUmi;
